module.exports = __webpack_public_path__ + "static/media/Icon_menu_location.950ac2e7.svg";